/**
 * PAS info modal — opens a native <dialog> "floating box" when the user
 * clicks a support link with a `data-pas-info-trigger` attribute.
 *
 * Wiring:
 *   <button data-pas-info-trigger="link-3" aria-controls="pas-info-modal-...">
 *   <dialog data-pas-info-modal="link-3" id="pas-info-modal-...">
 *
 * The trigger's `data-pas-info-trigger` value pairs it with the matching
 * dialog's `data-pas-info-modal` value within the same product-pas section.
 * Each section has its own scoped pair, so multiple PAS sections on a page
 * (preview, quick-add, etc.) don't cross-trigger.
 *
 * Backdrop click + Escape close the dialog. Close button uses
 * [data-pas-info-close].
 */

(function () {
  if (window.__pasInfoModalWired) return;
  window.__pasInfoModalWired = true;

  function findDialogForTrigger(trigger) {
    const id = trigger.getAttribute('aria-controls');
    if (id) {
      const byId = document.getElementById(id);
      if (byId instanceof HTMLDialogElement) return byId;
    }
    const key = trigger.getAttribute('data-pas-info-trigger');
    const scope = trigger.closest('.product-pas') || document;
    return scope.querySelector(`dialog[data-pas-info-modal="${key}"]`);
  }

  function openDialog(dialog) {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }

  // Trigger click → open paired dialog.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-pas-info-trigger]');
    if (trigger) {
      event.preventDefault();
      openDialog(findDialogForTrigger(trigger));
      return;
    }

    // Close button inside the dialog.
    const closeBtn = event.target.closest('[data-pas-info-close]');
    if (closeBtn) {
      event.preventDefault();
      closeDialog(closeBtn.closest('dialog'));
      return;
    }

    // Backdrop click — native <dialog> doesn't close on backdrop by default.
    // Detect: click target is the dialog itself (not a child), which means
    // the click landed on the ::backdrop area outside the inner content.
    const dialog = event.target.closest('dialog[data-pas-info-modal]');
    if (dialog && event.target === dialog) {
      closeDialog(dialog);
    }
  });
})();
